export const RISK_SEVERITIES = [
    'Superficial',
    'Minor',
    'Moderate',
    'Major',
    'Catastrophic'
];
